import { getCloudStorage, getFirestore } from '../../system/firebase';

import {
    SNACK_BAR_MESSAGE_DELETE,
    SNACK_BAR_MESSAGE_OPERATION_FAILED,
    SNACK_BAR_MESSAGE_SAVE,
    SNACK_BAR_MESSAGE_SAVED_TO_DRAFT,
    SNACK_BAR_MESSAGE_SAVED_TO_PUBLIC,
    UPLOADED_VIDEO_STATUS_PROCESSING,
    UPLOADED_VIDEO_STATUS_APPROVED,
} from '../constants';
import { convertFirebaseTimestampsToDate } from '../dateHelper';
import { deleteEmptyFields, mapDefinedFields } from '../dtoHelper';
import { scrubUrl } from '../linkHelper';
import { getNewLovOption, mapCreatableLovOptionToValue } from '../lovHelper';
import { convertEmployerTimestampsToDate } from '../employerHelper';

import { format as formatDate } from 'date-fns';

import _get from 'lodash/get';
import _set from 'lodash/set';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _noop from 'lodash/noop';
import _toLower from 'lodash/toLower';

export const loadProfileByEmployerId = ({ employerId, isEmpProfilePage, setData }) => {
    const db = getFirestore();

    const profileRef = db.collection('profilesEmp').doc(employerId);

    return profileRef.onSnapshot(docSnapshot => {
        let data = docSnapshot.data();
        const isPublic = _get(data, 'isPublic');
        const companyName = _get(data, 'info.companyName');

        data = isPublic || isEmpProfilePage ? { ...convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']) } : { isPublic: false, info: { companyName } };

        setData(data);
    });
};

export const loadProfileByCustomName = async ({ customName, setData, setEmployer }) => {
    const db = getFirestore();

    let employerId = null;
    const employersQuery = db.collection('employers').where('urlNameLower', '==', _toLower(customName)).limit(1);
    const employersSnapshot = await employersQuery.get();
    employersSnapshot.forEach(employerDoc => {
        const data = convertEmployerTimestampsToDate(employerDoc.data());
        employerId = employerDoc.id;
        setEmployer({ ...data, uid: employerId });
    });

    if (employerId) {
        const profileRef = db.collection('profilesEmp').doc(employerId);

        return profileRef.onSnapshot(docSnapshot => {
            let data = docSnapshot.data();
            const isPublic = _get(data, 'isPublic');
            const companyName = _get(data, 'info.companyName');

            data = isPublic ? { ...convertFirebaseTimestampsToDate(data, ['createDt', 'updateDt']) } : { isPublic: false, info: { companyName } };

            setData(data);
        });
    }
};

export const saveProfileBenefitBio = async ({ employerId, benefit, bio }) => {
    // const db = firebase.firestore();
    const db = getFirestore();
    const batch = db.batch();

    //------------------------------------------------------------------------------------
    // Get data
    //------------------------------------------------------------------------------------

    try {
        //------------------------------------------------------------------------------------
        // Update profileEmp doc
        //------------------------------------------------------------------------------------
        const profileEmpRef = db.collection('profilesEmp').doc(employerId);
        const dto = {
            benefit,
            bio,
        };
        batch.set(
            profileEmpRef,
            {
                info: { ...deleteEmptyFields(dto) },
                updateDt: new Date(),
            },
            { merge: true },
        );

        //------------------------------------------------------------------------------------
        // commit changes
        //------------------------------------------------------------------------------------
        await batch.commit();

        return true;
        ////
    } catch (error) {
        console.error('Save profile benefit and bio transaction failed: ', error);
        return false;
    }
};

export const saveProfileCompanyInfo = async ({ userId, employerId, data, closeDialog = _noop, setSnackbarMessage, setSnackbarErrorMessage }) => {
    // const db = firebase.firestore();
    const db = getFirestore();
    const batch = db.batch();

    //------------------------------------------------------------------------------------
    // Get data
    //------------------------------------------------------------------------------------
    const { companyName, country, state, city, cityLocation, newCity, companySize, industry, foundedYr, benefit, bio } = data;

    try {
        //------------------------------------------------------------------------------------
        // Update profileEmp doc
        //------------------------------------------------------------------------------------
        const profileEmpRef = db.collection('profilesEmp').doc(employerId);
        const dto = {
            // // companyName and location fields are now part of the 'employer' doc
            // companyName: companyName || null,
            // country: country || null,
            // state: state || null,
            // city: _get(city, 'name', null),
            // cityLocation: cityLocation || null,
            benefit,
            bio,
            companySize,
            industry: mapCreatableLovOptionToValue(industry),
            foundedYr: _isNil(foundedYr) ? undefined : +foundedYr,
        };
        batch.set(
            profileEmpRef,
            {
                info: { ...deleteEmptyFields(dto) },
                updateDt: new Date(),
            },
            { merge: true },
        );

        //------------------------------------------------------------------------------------
        // Update user doc
        //------------------------------------------------------------------------------------
        const employerRef = db.collection('employers').doc(employerId);
        const userDto = {
            companyName: companyName || null,
            country: country || null,
            state: state || null,
            city: city || null, //_get(city, 'name', null),
            cityLocation: cityLocation || null,
        };
        batch.set(
            employerRef,
            {
                ...deleteEmptyFields(userDto),
                updateDt: new Date(),
            },
            { merge: true },
        );

        //------------------------------------------------------------------------------------
        // Add new LOV options (if any)
        //------------------------------------------------------------------------------------
        const newLovOptionRef = db.collection('newLovOptions').doc();
        const newLovOptionsDto = {};

        const newIndustryOption = getNewLovOption(industry);
        if (newIndustryOption) {
            _set(newLovOptionsDto, 'newIndustryOptions', [newIndustryOption]);
        }

        // const newOccupationOptions = getNewLovOptions(occupation);
        // if (newOccupationOptions.length > 0) {
        //     _set(newLovOptionsDto, 'newOccupationOptions', newOccupationOptions);
        // }

        if (newCity) {
            _set(newLovOptionsDto, 'newCityOption', newCity);
            _set(newLovOptionsDto, 'newCityOptionState', state || 'Unknown State');
            _set(newLovOptionsDto, 'newCityOptionCountry', country || 'Unknown Country');
        }

        if (!_isEmpty(newLovOptionsDto)) {
            batch.set(newLovOptionRef, {
                ...newLovOptionsDto,
                createDt: new Date(),
                createBy: userId,
            });
        }

        //------------------------------------------------------------------------------------
        // commit changes
        //------------------------------------------------------------------------------------
        await batch.commit();

        // console.log('Transaction successfully committed!');
        closeDialog();
        setSnackbarMessage(SNACK_BAR_MESSAGE_SAVE);
    } catch (error) {
        console.error('Save profile company info transaction failed: ', error);
        console.log(error);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
    }
};

export const saveProfileBranding = async ({ logoFile, bannerFile, employerId, setSnackbarMessage, setSnackbarErrorMessage, setProgress, closeCropper }) => {
    const db = getFirestore();
    const now = new Date();

    // assume there will always be either a logoFile or a bannerFile
    const timestampStr = formatDate(now, 'yyyyMMddHHmmss_T');
    const storagePath = logoFile ? `employers/${employerId}/profilePicture/${timestampStr}` : `employers/${employerId}/banner/${timestampStr}`;
    const file = logoFile || bannerFile;
    const flagDto = logoFile ? { isEmpProfilePic: 'Y' } : { isEmpBanner: 'Y' };

    const storageRef = getCloudStorage().ref();
    const logoRef = storageRef.child(storagePath);
    const uploadTask = logoRef.put(file, {
        contentType: file.type,
        customMetadata: {
            employerId,
            origFilename: timestampStr,
            ...flagDto,
        },
    });

    const uploadedImagesRef = db.collection('uploadedImages').doc();

    uploadTask.on(
        'state_changed',
        snapshot => {
            const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            setProgress(progress);
        },
        error => console.error('File upload failed', error),
        async () => {
            try {
                const url = await logoRef.getDownloadURL();
                setProgress(null);

                //------------------------------------------------------------------------------------
                // creating Uploaded Image Doc
                //------------------------------------------------------------------------------------
                const uploadedImageDto = {
                    createDt: now,
                    isEmpProfilePic: logoFile ? true : null,
                    status: UPLOADED_VIDEO_STATUS_PROCESSING, // P, F, A, C, D
                    updateDt: now,
                    url,
                    employerId,
                    isEmpBanner: logoFile ? null : true,
                };

                console.log(mapDefinedFields(uploadedImageDto));
                await uploadedImagesRef.set(mapDefinedFields(uploadedImageDto));

                if (logoFile) {
                    const employerRef = db.collection('employers').doc(employerId);
                    await employerRef.update({ updateDt: now, uploadedPictureStatus: UPLOADED_VIDEO_STATUS_PROCESSING });
                } else {
                    const profileEmpRef = db.collection('profilesEmp').doc(employerId);
                    await profileEmpRef.set({ updateDt: now, uploadedPictureStatus: UPLOADED_VIDEO_STATUS_PROCESSING }, { merge: true });
                }

                closeCropper && closeCropper();
                setSnackbarMessage(SNACK_BAR_MESSAGE_SAVE);
            } catch (error) {
                console.error('Save profile branding transaction failed: ', error);
                console.log(error);
                setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
            }
        },
    );
};

export const resetEmpBrandingSeResults = async ({ employerId, setSnackbarMessage, setSnackbarErrorMessage }) => {
    const db = getFirestore();

    const employerRef = db.collection('employers').doc(employerId);
    const employerProfileRef = db.collection('profilesEmp').doc(employerId);

    return db
        .runTransaction(transaction => {
            // This code may get re-run multiple times if there are conflicts.
            return transaction.get(employerRef).then(function (doc) {
                if (!doc.exists) {
                    throw new Error('Profile document does not exist!');
                }

                const dto = {
                    seResult: null, // for removing stats old of bad video.
                    uploadedPictureStatus: UPLOADED_VIDEO_STATUS_APPROVED, // for reseting the video status
                };

                transaction.update(employerRef, {
                    ...deleteEmptyFields(dto),
                    updateDt: new Date(),
                });

                transaction.update(employerProfileRef, {
                    ...deleteEmptyFields(dto),
                    updateDt: new Date(),
                });
            });
        })
        .then(function () {
            // console.log('Transaction successfully committed!');
            // dataDidSave();
            setSnackbarMessage(SNACK_BAR_MESSAGE_SAVE);
        })
        .catch(function (error) {
            console.error('Save profile type transaction failed: ', error);
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        });
};

export const deleteCompanyLogo = async ({ employerId, profilePicUrl, setSnackbarMessage, setSnackbarErrorMessage, postDelete }) => {
    const db = getFirestore();
    const now = new Date();

    const timeStamp = profilePicUrl.split('%2F')[3].split('?alt')[0];
    const storageRef = getCloudStorage().ref();
    const picRef = storageRef.child(`employers/${employerId}/profilePicture/${timeStamp}`);

    try {
        await picRef.delete();

        const employerRef = db.collection('employers').doc(employerId);
        await employerRef.update({ profilePicUrl: '', updateDt: now });
        if (postDelete) {
            postDelete();
        }
        setSnackbarMessage(SNACK_BAR_MESSAGE_DELETE);
    } catch (error) {
        setSnackbarErrorMessage();
    }
};

export const deleteCompanyBanner = async ({ employerId, bannerUrl, setSnackbarMessage, setSnackbarErrorMessage, postDelete }) => {
    const db = getFirestore();
    const now = new Date();

    const timeStamp = bannerUrl.split('%2F')[3].split('?alt')[0];
    const storageRef = getCloudStorage().ref();
    const picRef = storageRef.child(`employers/${employerId}/banner/${timeStamp}`);

    try {
        await picRef.delete();

        const profileRef = db.collection('profilesEmp').doc(employerId);
        await profileRef.set({ brand: { bannerUrl: '' }, updateDt: now }, { merge: true });
        if (postDelete) {
            postDelete();
        }
        setSnackbarMessage(SNACK_BAR_MESSAGE_DELETE);
    } catch (error) {
        setSnackbarErrorMessage();
    }
};

export const saveProfileSocialMedia = async ({
    employerId,
    facebookUrl,
    linkedInUrl,
    youTubeUrl,
    instagramUrl,
    twitterUrl,
    websiteUrl,
    tikTokUrl,
    gitHubUrl,
    setSnackbarMessage,
    setSnackbarErrorMessage,
}) => {
    facebookUrl = scrubUrl(facebookUrl);
    linkedInUrl = scrubUrl(linkedInUrl);
    youTubeUrl = scrubUrl(youTubeUrl);
    twitterUrl = scrubUrl(twitterUrl);
    instagramUrl = scrubUrl(instagramUrl);
    websiteUrl = scrubUrl(websiteUrl);
    tikTokUrl = scrubUrl(tikTokUrl);
    gitHubUrl = scrubUrl(gitHubUrl);

    const db = getFirestore();

    const profileRef = db.collection('profilesEmp').doc(employerId);

    const dto = {
        social: deleteEmptyFields({
            facebookUrl,
            linkedInUrl,
            youTubeUrl,
            instagramUrl,
            twitterUrl,
            websiteUrl,
            tikTokUrl,
            gitHubUrl,
        }),
    };

    try {
        await db.runTransaction(transaction => {
            return transaction.get(profileRef).then(function (doc) {
                if (!doc.exists) {
                    throw new Error('Document does not exist!');
                }

                transaction.set(profileRef, dto, { merge: true });
            });
        });

        // console.log('Transaction successfully committed!');
        setSnackbarMessage(SNACK_BAR_MESSAGE_SAVE);
        return true;
        ////
    } catch (error) {
        console.error('Save Profile social media transaction failed: ', error);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        return false;
    }
};

export const someAction = ({ tempCase, setSnackbarMessage, setSnackbarErrorMessage }) => {
    switch (tempCase) {
        case 1:
            setSnackbarMessage(SNACK_BAR_MESSAGE_SAVE);
            break;
        case 2:
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
            break;
        default:
            setSnackbarMessage(SNACK_BAR_MESSAGE_SAVE);
    }
};

export const saveProfileType = ({ employerId, isPublic, dataDidSave, setSnackbarMessage, setSnackbarErrorMessage }) => {
    const db = getFirestore();

    const profileRef = db.collection('profilesEmp').doc(employerId);

    return db
        .runTransaction(transaction => {
            // This code may get re-run multiple times if there are conflicts.
            return transaction.get(profileRef).then(function (doc) {
                if (!doc.exists) {
                    throw new Error('Profile document does not exist!');
                }

                const dto = {
                    isPublic: isPublic ? true : false,
                };

                transaction.update(profileRef, {
                    ...deleteEmptyFields(dto),
                    updateDt: new Date(),
                });
            });
        })
        .then(function () {
            // console.log('Transaction successfully committed!');
            if (dataDidSave) dataDidSave();
            setSnackbarMessage(isPublic ? SNACK_BAR_MESSAGE_SAVED_TO_PUBLIC : SNACK_BAR_MESSAGE_SAVED_TO_DRAFT);
        })
        .catch(function (error) {
            console.error('Save profile type transaction failed: ', error);
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        });
};
export const changeEmpProfileToDraft = async ({ employerId, setSnackbarMessage, setSnackbarErrorMessage }) => {
    const db = getFirestore();

    const profileRef = db.collection('profilesEmp').doc(employerId);

    try {
        await db.runTransaction(transaction => {
            return transaction.get(profileRef).then(function (doc) {
                if (!doc.exists) throw new Error('Profile document does not exist!');

                const dto = { isPublic: false };

                transaction.update(profileRef, {
                    ...deleteEmptyFields(dto),
                    updateDt: new Date(),
                });
            });
        });
        setSnackbarMessage(SNACK_BAR_MESSAGE_SAVE);
        return true;
        ////
    } catch (error) {
        console.error('Save profile type transaction failed: ', error);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        return false;
    }
};
